<template>
	<view class="box">
		<view class="box_list">
			<view class="box_list_item">
				<view class="box_list_item_label">
					<text>快递单号</text>
					<text>*</text>
				</view>
				<view class="box_list_item_val">
					<input type="text" placeholder="请填写" placeholder-style="text-align: right;color: #999999;font-size: 28rpx;font-weight: 500;" />
					<image src="@/static/logo.png" mode="widthFix"></image>
				</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">
					<text>快递公司</text>
					<text>*</text>
				</view>
				<view class="box_list_item_val">
					<input type="text" placeholder="请填写" placeholder-style="text-align: right;color: #999999;font-size: 28rpx;font-weight: 500;" />
				</view>
			</view>
			<view class="box_list_item">
				<view class="box_list_item_label">
					<text>联系电话</text>
				</view>
				<view class="box_list_item_val">
					<text>17389409940</text>
				</view>
			</view>
		</view>
		<view class="box_desc">
			<view class="box_desc_label">补充描述和凭证</view>
			<view class="box_desc_ipt">
				<textarea placeholder="补充描述，有助于商家更好的处理售后问题"></textarea>
				<view class="box_desc_ipt_list">
					<view class="box_desc_ipt_list_item">
						<image src="@/static/icon/ic_pingzheng@2x.png" mode="widthFix"></image>
					</view>
				</view>
			</view>
		</view>
		<view class="box_zw"></view>
		<view class="box_footer">
			<view class="box_footer_btn">提交</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_list {
			display: flex;
			flex-direction: column;
			background-color: #ffffff;
			.box_list_item {
				padding: 28rpx 32rpx;
				display: flex;
				justify-content: space-between;
				.box_list_item_label {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						&:nth-child(2) {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #D95A5A;
						}
					}
				}
				.box_list_item_val {
					display: flex;
					align-items: center;
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
					input {
						text-align: right;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #000000;
					}
					image {
						width: 28rpx;
						height: 28rpx;
						margin-left: 14rpx;
					}
				}
			}
		}
		.box_desc {
			width: 100%;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.box_desc_label {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 36rpx;
			}
			.box_desc_ipt {
				width: 100%;
				padding: 28rpx 24rpx;
				background-color: #F5F5F5;
				box-sizing: border-box;
				display: flex;
				flex-direction: column;
				textarea {
					width: 100%;
					height: 80rpx;
				}
				.box_desc_ipt_list {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					margin-top: 50rpx;
					.box_desc_ipt_list_item {
						width: 172rpx;
						height: 172rpx;
						image {
							width: 100%;
							height: 100%;
						}
					}
				}
			}
		}
		.box_zw {
			width: 100%;
			height: calc(112rpx + env(safe-area-inset-bottom));
		}
		.box_footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			background-color: #ffffff;
			box-sizing: border-box;
			padding: 20rpx 56rpx calc(20rpx + env(safe-area-inset-bottom)) 56rpx;
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
</style>